<template>
  <tr>
    <td
      class="text-center align-middle"
      v-if="showHeader"
      v-bind:rowspan="item.items.length > 1 ? item.items.length : 1"
    >
      <span class="form-control form-control-plaintext">{{rowIndex + 1}}</span>
    </td>
    <td
      class="form-group text-center align-middle"
      v-if="showHeader"
      v-bind:rowspan="item.items.length > 1 ? item.items.length : 1"
    >
      {{item.jobNumber}}
      <br />
      {{item.jobTypeName}}
    </td>
    <td
      v-if="showHeader"
      class="form-group text-center align-middle"
      v-bind:rowspan="item.items.length > 1 ? item.items.length : 1"
    >{{item.jobDate}}</td>
    <td
      class="form-group text-center align-middle"
      v-if="showHeader"
      v-bind:rowspan="item.items.length > 1 ? item.items.length : 1"
    >{{item.originLocationName}}</td>
    <td
      class="form-group text-center align-middle"
      v-if="showHeader"
      v-bind:rowspan="item.items.length > 1 ? item.items.length : 1"
    >{{item.destinationLocationName}}</td>
    <template v-if="item.items.length > 0">
      <td
        class="text-center align-middle"
      >{{item.items[itemIndex].materialCode}} {{item.items[itemIndex].materialName}}</td>
      <td
        class="text-right align-middle"
      >{{item.items[itemIndex].checkedQuantity}}/{{item.items[itemIndex].quantity}}</td>
      <td class="text-center align-middle">{{item.items[itemIndex].baseUnit}}</td>
    </template>
    <template v-else>
      <td>&nbsp;</td>
      <td>&nbsp;</td>
      <td>&nbsp;</td>
    </template>
    <td
      v-if="showHeader"
      class="text-center align-middle"
      v-bind:rowspan="item.items.length > 1 ? item.items.length : 1"
    ></td>
  </tr>
</template>

<script>
import axios from "axios";

export default {
  props: {
    isEditable: {
      type: Boolean,
      default: true
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    rowIndex: Number,
    itemIndex: Number,
    showHeader: {
      type: Boolean,
      default: true
    },
    rootItems: {
      type: Array,
      required: true
    },
    item: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// App/Components/Job/JobRefJobRow.vue